<input
  type="text"
  [(ngModel)]="phoneNrInput"
  name="phoneNrInput"
  id="phoneNrInput"
  required
  #phoneNrInputVar="ngModel"
  [class.empty]="!phoneNrInputVar.value"
  (ngModelChange)="updatePhoneNumber()"
  data-zid="phone"
/>
